import { Card } from "antd";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { formatMinutes } from "../utils";

interface DonutItem {
  name: string;
  value: number;
  color: string;
}

interface DonutChartProps {
  data: DonutItem[];
  totalDurationMinutes: number | null;
}

const DonutChart = ({ data, totalDurationMinutes }: DonutChartProps) => (
  <Card style={{ width: 304, flexShrink: 0 }} bodyStyle={{ padding: 0 }}>
    <PieChart width={288} height={288}>
      <Pie
        data={data}
        cx={144}
        cy={144}
        innerRadius={80}
        outerRadius={120}
        dataKey="value"
        paddingAngle={1}
      >
        {data.map((entry) => (
          <Cell key={entry.name} fill={entry.color} />
        ))}
      </Pie>
      <Tooltip formatter={(value) => formatMinutes(Number(value))} />
      {totalDurationMinutes !== null && (
        <text
          x={144}
          y={144}
          textAnchor="middle"
          dominantBaseline="central"
          style={{ fontSize: 16, fontWeight: 700, fill: "#262626" }}
        >
          {formatMinutes(totalDurationMinutes)}
        </text>
      )}
    </PieChart>
  </Card>
);

export default DonutChart;
